import { Footer } from '@fe-toolkit/web-components/ssr'
import { footerLinks } from '@fe-toolkit/utility'

export default function FallbackFooter() {
  return <Footer links={footerLinks} small={false} />
}
